import axios from 'axios';

import {
    ContactListResponse,
    CreateTicketRequest,
    CreateTicketResult,
    SaveTicketDraftRequest,
    TicketAssignmentPreference,
    TicketCreationOptions,
    TicketDraft,
    TicketDraftSummary
} from '../schemas';

export function requestCreateTicket(payload: CreateTicketRequest, files: File[]) {
    const formData = new FormData();
    formData.append('task_owner_id', payload.task_owner_id);
    formData.append('work_group_id', payload.work_group_id);
    formData.append('first_assign_id', payload.first_assign_id);
    formData.append('subject', payload.subject);
    formData.append('start_at', payload.start_at);
    formData.append('end_at', payload.end_at);
    formData.append('send_email', payload.send_email ? 'true' : 'false');

    if (payload.draft_id) formData.append('draft_id', payload.draft_id);
    if (payload.sub_work_group_id) {
        formData.append('sub_work_group_id', payload.sub_work_group_id);
    }
    if (payload.haste_code) formData.append('haste_code', payload.haste_code);
    if (payload.detail) formData.append('detail', payload.detail);

    payload.participant_ids.forEach(participantId => {
        formData.append('participant_ids', participantId);
    });
    files.forEach((file, index) => {
        formData.append(`file_${index + 1}`, file, file.name);
    });

    return axios.post<CreateTicketResult>('/v2/ticket-creation/tasks', formData);
}

export function requestTicketCreationOptions(linkId: string) {
    return axios.get<TicketCreationOptions>('/v2/ticket-creation/options', {
        params: { link_id: linkId }
    });
}

export function requestWorkGroupUsers(
    linkId: string,
    workGroupCode: string,
    signal?: AbortSignal
) {
    return axios.get<ContactListResponse>('/v2/ticket-creation/workgroup-users', {
        params: {
            link_id: linkId,
            work_group_code: workGroupCode
        },
        signal
    });
}

export function requestAssignmentPreference(
    workGroupCode: string,
    signal?: AbortSignal
) {
    return axios.get<TicketAssignmentPreference>(
        '/v2/ticket-creation/assignment-preference',
        {
            params: { work_group_code: workGroupCode },
            signal
        }
    );
}

export function requestTicketDrafts() {
    return axios.get<TicketDraftSummary[]>('/v2/ticket-drafts');
}

export function requestTicketDraft(draftId: string) {
    return axios.get<TicketDraft>(`/v2/ticket-drafts/${draftId}`);
}

export function requestCreateTicketDraft(payload: SaveTicketDraftRequest) {
    return axios.post<TicketDraft>('/v2/ticket-drafts', payload);
}

export function requestUpdateTicketDraft(draftId: string, payload: SaveTicketDraftRequest) {
    return axios.put<TicketDraft>(`/v2/ticket-drafts/${draftId}`, payload);
}

export function requestDeleteTicketDraft(draftId: string) {
    return axios.delete(`/v2/ticket-drafts/${draftId}`);
}
